import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '高潮喷水是真实存在的生理现象吗？',
    answer: '是的。大量医学研究证实，高潮喷水（女性射液）是一个真实的生理现象。超声波成像、生化分析和神经科学研究都提供了充分的证据。它在医学文献中被记录和研究已有数十年历史，并非虚构或夸大。',
  },
  {
    question: '高潮喷水是否意味着尿失禁？',
    answer: '不是。虽然喷出的液体从尿道排出，但其化学成分与尿液有显著区别。高潮喷水液体含有高浓度的前列腺特异性抗原（PSA）、葡萄糖和果糖，而肌酐和尿素含量远低于尿液。这是一种腺体分泌液，与尿失禁有本质区别。',
  },
  {
    question: '所有女性都能体验高潮喷水吗？',
    answer: '并非所有女性都会经历高潮喷水。研究显示约有10%-54%的女性曾经历过此现象。这与个人的解剖结构、激素水平、盆底肌状态等多种因素有关。无论是否体验过，都是完全正常的，不代表性功能有任何问题。',
  },
  {
    question: '高潮喷水对身体健康有影响吗？',
    answer: '高潮喷水本身对身体健康没有负面影响，它是一个自然的生理过程。事实上，性高潮（无论是否伴随喷水）对健康有多方面的益处，包括缓解压力、改善睡眠、增强盆底肌功能和促进伴侣情感连接。',
  },
  {
    question: '如何区分高潮喷水与其他体液？',
    answer: '高潮喷水液体通常清亮、无明显气味，量从几毫升到几十毫升不等。它与阴道润滑液不同（后者来自阴道壁的渗出），也与宫颈黏液不同。实验室分析是区分的最准确方法，但日常生活中可以通过量、气味和伴随的生理感受来初步判断。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const schemaFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaFAQ) }}
      />
      <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              常见问题解答
            </h2>
            <p className="mt-2 text-sm text-foreground-500">关于高潮喷水的常见疑问，专业医生为你解答</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}